import { render } from "./BaseTreeViewDefectsSorted.vue?vue&type=template&id=1c2b9352"
import script from "./BaseTreeViewDefectsSorted.vue?vue&type=script&lang=js"
export * from "./BaseTreeViewDefectsSorted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__